import Loading from "../../components/Dashboard/Loading";
import { useGetPlantationProjects } from "../../queries/project";
import { createColumnHelper } from "@tanstack/react-table";
import TanStackTable from "../../components/TanStackTable";
import { useMemo } from "react";
import { useNavigate } from "react-router";
import Chip from "../../components/Chip";
const EditIcon = require("../../utils/media/icons/enter.png");

const ProjectPlantation = () => {

    const navigate = useNavigate();
    
    const { data: plantationProjects, isPending: isPlantationProjectsPending } = useGetPlantationProjects();
    const columnHelper = createColumnHelper();

    const columns = useMemo(() => [
        columnHelper.display({
            id: 'srno',
            header: 'Sr No.',
            cell: info => info.row.index + 1,
        }),
        columnHelper.accessor(row => row.userId?.username, {
            id: 'username',
            header: 'Username',
            cell: info => info.getValue() || 'N/A',
        }),
        columnHelper.accessor(row => row.campaignId?.title, {
            id: 'campaign',
            header: 'Campaign',
            cell: info => info.getValue() || 'N/A',
        }),
        columnHelper.accessor(row => row.projectId?.name, {
            id: 'project',
            header: 'Project',
            cell: info => info.getValue() || 'N/A',
        }),
        columnHelper.accessor('pointsDonated', {
            header: 'Points Donated',
            align: 'center',
            cell: info => info.getValue() || 0,
        }),
        columnHelper.accessor('treesPlanted', {
            header: 'Trees Planted',
            align: 'center',
            cell: info => info.getValue() || 0,
        }),
        columnHelper.accessor('carbonSavings', {
            header: 'Carbon Savings',
            align: 'center',
            cell: info => info.getValue() || 0,
        }),
        columnHelper.accessor('createdAt', {
            header: 'Donated At',
            align: 'center',
            cell: info => info.getValue() ? new Date(info.getValue()).toLocaleString('en-GB', {
                day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
            }) : 'N/A',
        }),
        columnHelper.accessor('certificate', {
            header: 'Certificate',
            align: 'center',
            cell: info => (
                <Chip color={info.getValue() ? 'green' : 'inactive'} value={info.getValue() ? 'Yes' : 'No'} />
            ),
        }),
        columnHelper.display({
            id: 'actions',
            header: 'Actions',
            align: 'center',
            cell: info => (
                <button
                    className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7"
                    onClick={() => navigate('/projects/plantation-project-details', { state: { projectId: info.row.original._id } })}
                >
                    <img src={EditIcon} className="size-5" alt="view" />
                </button>
            ),
        }),
    ], []);

    if (isPlantationProjectsPending) {
        return <Loading />;
    }

    return (
        <section className="flex flex-col pt-5 w-full mt-5 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
            <div className="flex flex-col pr-px w-full max-md:max-w-full">
                <h1 className="self-start text-lg font-bold pl-6 pb-4">Plantation Project Participants</h1>
                <div className="pl-5">
                    <TanStackTable
                        data={plantationProjects || []}
                        columns={columns}
                        enablePagination={true}
                    />
                </div>
            </div>
        </section>
    );
}

export default ProjectPlantation;